export default {
  title: 'Produits imprimés personnalisés',
  fields: {
    name: 'Nom',
    format: 'Type de produit',
  },
  buttons: {
    upload_product: 'Lancer le téléversement',
    preview: 'Aperçu',
    edit: 'Modifier',
  },
};
